module.exports = __webpack_public_path__ + "img/T7A6662.3ed39c36.jpg";